import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { createPolymorphicComponent } from '../../factory/factory.utils.mjs';
import { parseStyleProps } from '../../utils/styleProps.mjs';
import { useRandomClassName } from '../../utils/hooks/hooks.mjs';
import { InlineStyles } from '../InlineStyles/InlineStyles.mjs';
import { extractStyleProps, BOX_STYLE_PROPS_DATA } from './Box.utils.mjs';

const Box = createPolymorphicComponent(
  forwardRef(({ component, className, style, mod, renderRoot, trackingAttributes, ...rest }, ref) => {
    const responsiveClassName = useRandomClassName();
    const { styleProps, rest: restFiltered } = extractStyleProps(rest);
    const parsedStyleProps = parseStyleProps({
      styleProps,
      data: BOX_STYLE_PROPS_DATA
    });
    const Element = component || "div";
    const props = {
      ref,
      className: clsx(mod && `${mod}-mod`, className, parsedStyleProps.hasResponsiveStyles && responsiveClassName) || void 0,
      style: {
        ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {},
        ...style
      },
      ...restFiltered,
      ...trackingAttributes
    };
    return /* @__PURE__ */ React.createElement(React.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ React.createElement(InlineStyles, { selector: `.${responsiveClassName}`, styles: parsedStyleProps.styles, media: parsedStyleProps.media }), typeof renderRoot === "function" ? renderRoot(props) : /* @__PURE__ */ React.createElement(Element, { ...props }));
  })
);

export { Box };
